// src/libs/api.js
import sendRequest from '@/libs/sendRequest'
import _Store from '@/store'

// ----------------- helpers -----------------
const ISO = d => new Date(d).toISOString().slice(0, 10)
const daysRange = (from, to) => {
  const out = []
  const cur = new Date(from); const end = new Date(to)
  while (cur <= end) { out.push(ISO(cur)); cur.setDate(cur.getDate() + 1) }
  return out
}

// ----------------- MOCK DATA -----------------
function overview () {
  return {
    travellers:  { total: 0, active: 0, deactive: 0 },
    localguides: { total: 0, active: 0, deactive: 0 },
    trips:       { total: 0, open: 0, ongoing: 0, completed: 0, weekTotal: 0, monthTotal: 0 },
    amounts:     { total: 0, week: 0, month: 0 }
  }
}
function tripSeries (from, to) {
  return daysRange(from, to).map((d, i) => {
    const base = 20 + ((i * 7) % 18)
    const open = (base % 7)
    const ongoing = (base % 9)
    const completed = base + 10
    return { date: d, open, ongoing, completed, total: open + ongoing + completed }
  })
}
function amountSeries (from, to) {
  return daysRange(from, to).map((d, i) => ({
    date: d,
    amount: 20000 + ((i * 13) % 11) * 5000
  }))
}

// --------------- API WRAPPERS ----------------
export async function fetchOverview (params) {
  try {
    const res = await sendRequest('admin/metrics/overview', 'GET', null, params, _Store.getters.getHeaders)
    if (res?.success && res?.data) return res.data
    return overview()
  } catch (e) {
    console.warn('overview → mock fallback:', e?.message)
    return overview()
  }
}

export async function fetchTripSeries (params = {}) {
  const from = params.from || ISO(new Date(Date.now() - 30 * 86400000))
  const to   = params.to   || ISO(new Date())
  try {
    const res = await sendRequest('admin/series/trips', 'GET', null, params, _Store.getters.getHeaders)
    if (res?.success && res?.data) return res.data
    return tripSeries(from, to)
  } catch (e) {
    console.warn('trips series → mock fallback:', e?.message)
    return tripSeries(from, to)
  }
}

export async function fetchAmountSeries (params = {}) {
  const from = params.from || ISO(new Date(Date.now() - 30 * 86400000))
  const to   = params.to   || ISO(new Date())
  try {
    const res = await sendRequest('admin/series/amounts', 'GET', null, params, _Store.getters.getHeaders)
    if (res?.success && res?.data) return res.data
    return amountSeries(from, to)
  } catch (e) {
    console.warn('amount series → mock fallback:', e?.message)
    return amountSeries(from, to)
  }
}
